module.exports = "<app-login-header></app-login-header>\n<app-static-selector></app-static-selector>\n<app-footer></app-footer>\n\n\n"